/** @format */

import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { userTypes } from "../../utils/constants";
import { getHeaderConfig, getMobileHeaderConfig } from "./config";
import Button from "@mui/material/Button";
import { selectStoreType } from "../Store/config";
import CustomModal from "../../core/modal";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Select from "react-select";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
const Department = () => {
  const [store, setStore] = useState({});
  const [addDepartment, setAddDepartment] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState([]);
  const [departmentName, setDepartmentName] = useState("");
  const [showCreateDepartmentOption, setshowCreateDepartmentOption] =
    useState(true);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 12,
    sortBy: "-createdAt",
  });

  const navigate = useNavigate();
  useEffect(() => {
    const userCredentials = getOfflineData("user");
    if (!userCredentials) {
      navigate("/login");
    } else {
      const { type } = userCredentials;
      if (type === userTypes.STORE_OWNER) {
        setshowCreateDepartmentOption(false);
      } else {
        setshowCreateDepartmentOption(true);
      }
      loadData(filters);
    }
  }, [navigate, filters]);
  const addDepartmentFormHandler = () => {
    setAddDepartment(true);
  };

  const addNameHandler = (event) => {
    setName(event.target.value);
  };
  const addStoreTypeHandler = (event) => {
    setType(event);
  };
  const payload = {
    allowedStoreTypes: type.map((item) => item.value),
    name: name,
  };

  //Add New Department
  const formSubmitHandler = () => {
    if (!name?.trim() || type.length === 0) {
      toast.error("Empty Fields Not Allowed", { autoClose: 2000 });
    } else {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CREATE_DEPARTMENT}`,
        payload
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            toast.success("Department Created Successfully");
            loadData(filters);
            setName("");
            setType([]);
            setAddDepartment(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  //get departments
  const loadData = (params) => {
    const filterParams =
      params && typeof params === "object" ? { ...params } : { ...filters };

    if (!filterParams.page) {
      filterParams.page = filters.page;
    }
    if (!filterParams.limit) {
      filterParams.limit = filters.limit;
    }
    if (!filterParams.sortBy) {
      filterParams.sortBy = filters.sortBy;
    }
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_DEPARTMENT}`,
      null,
      filterParams
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response?.message, { autoClose: 2000 });
          return;
        }
        if (response) {
          setStore(response);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <div className="department-container">
        <div className="button-div">
          <div className="search-field">
            <TextField
              fullWidth
              sx={{ my: 1 }}
              label="Search by department name"
              onChange={(e) => setDepartmentName(e?.target?.value)}
              value={departmentName}
              size="small"
            />

            <SearchIcon
              className="main-search-icon"
              onClick={() => {
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  page: 1,
                  departmentName,
                }));
              }}
            />
          </div>
          {showCreateDepartmentOption && (
            <Button
              variant="contained"
              className="button"
              onClick={addDepartmentFormHandler}
            >
              Create Department
            </Button>
          )}
        </div>
        <div className="si-hide-mobile">
          <SiTable
            header={getHeaderConfig(loadData)}
            data={store.results || []}
            pageCount={store.totalPages}
            filters={filters}
            onChange={(event, page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
          ></SiTable>
        </div>
        <div className="si-hide-web">
          <SiTable
            header={getMobileHeaderConfig()}
            data={store.results || []}
            filters={filters}
            pageCount={store.totalPages}
            onChange={(event, page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
          ></SiTable>
        </div>
      </div>
      {addDepartment && (
        <CustomModal
          title="New Department"
          contentClassName={{ headerBackgroundColor: "#008952" }}
          onClose={() => {
            setAddDepartment(false);
            setName("");
            setType([]);
          }}
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="name"
              label="Name"
              required
              multiline
              sx={{ my: 1 }}
              onChange={addNameHandler}
              value={name}
              size="small"
            />
            <Select
              value={type}
              required
              options={selectStoreType}
              isMulti
              onChange={addStoreTypeHandler}
              getOptionLabel={(op) => op.label}
              getOptionValue={(op) => op.value}
              placeholder={type.length === 0 ? "type" : ""}
            />
            <Stack direction="row" spacing={2} sx={{ my: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={formSubmitHandler}
                fullWidth
              >
                Create
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  setAddDepartment(false);
                  setName("");
                  setType([]);
                }}
                fullWidth
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </>
  );
};

export default Department;
